import { useEffect, useState } from "react";
import { Heading, HStack, Button, VStack, Box, Select, Image, useColorMode } from "@chakra-ui/react";
import { useWeb3React } from "@web3-react/core";
import BridgeArtifacts from "../artifacts/contracts/Bridge.sol/Bridge.json";
import ERC721Artifacts from "../artifacts/@openzeppelin/contracts/token/ERC721/ERC721.sol/ERC721.json";
import Moralis from 'moralis/node';
import {
    NumberInput,
    NumberInputField,
    NumberInputStepper,
    NumberIncrementStepper,
    NumberDecrementStepper,
  } from '@chakra-ui/react'
import Web3 from "web3";

function Bridge () {
    
    const [ tokenId , settokenId] = useState(0);
    const [transactionValue, setTransactionValue] = useState("0.1");
    const [ isVerified , setisVerified] = useState(false);
    const [ verifying , setVerifying] = useState(false);
    const [verifiedImageLink, setVerifiedImageLink] = useState() 

    const [ dstChainId, setDstChainId ] = useState(10010);

    const {colorMode, setColormode} = useColorMode()
    const { account, library, chainId } = useWeb3React();
    const data = useWeb3React();
    Moralis.start({appId: "1oUCsVB7OaaoCl2IP6Y6tejwbrndhCVBsaLNMRjb", serverUrl: "https://vfy1shsqdr4r.usemoralis.com:2053/server"})

    // const [nfts, setnfts] = useState([]);
    // const ckey = "ckey_9e3e88c3bc2949e19ba169dc7ae";

    const fetchNFTs = async (acc, chainId) => {
        // const url = "https://api.covalenthq.com/v1/" + chainId + "/address/" + acc + "/balances_v2/?nft=true&key="+ckey;
        
        // let assets = await axios.get(url);
        // console.log(assets);
        // assets = assets.data.items.filter(x => x.type == "nfts");
        // setnfts(assets);
        // console.log(assets);

        // const options = {
        //     address: "0x0DBcCB2F2B16926dD60770ff72C6bF6E5cAb3CBE"
        // };
        // const allNFTS = await Moralis.Web3API.account.getNFTs(options);
        // console.log(allNFTS)

        // const nfts_filtered = allNFTS.result.filter( nft => (nft.metadata !== null) )
        // const ipfsNftImages = nfts_filtered.map( nft => ("https://ipfs.io/ipfs/" + JSON.parse(nft.metadata).image.split("//")[1]) ) 
        // setNftImages(nftImageLinks);

    }

    const getWeb3 = async (lib) => {
        return new Web3(lib.currentProvider);
    }

    const bridgeAddresses = {
        4: "0x5DE299fff545FD1dE590d1B49Ed48245AB793315", // rinkeby
    }

    const chainToLzChain = {
        4: 10001,
        421611: 10010,
    }

    const lzChainToName = {
        10001: "Rinkeby",
        10010: "Arbitrum"
    }

    const nftAddr = {
        4: "0xE7699383D286253B09aE72E550Fa4Bb03DC75Ab8",
        421611: "0x9F148AcA2335c031632264097F140448A531e2bD",
    }

    // const ipfsForNFT = {
    //     4: 
    // }

    const meghIPFS = "QmYSEBXsWkfjb26924YTmAzYETXTzBgR2HrQK98RD78AHp";

    const getWhitelistedNFTCollections = async (account, chainId, library) => {
        const web3 = await getWeb3(library);
        const bridge = new web3.eth.Contract(BridgeArtifacts.abi, bridgeAddresses[chainId]);

        const wlCount = await bridge.methods.countWhitelistedCollections().call();

        console.log(wlCount);
        
        const wl = [];
        for(let i = 0; i < wlCount; i++) {
            const collection = await bridge.methods.whitelistedCollections(i).call();
            wl.push(collection);
        }

        // console.log(wl);
        return wl;
    } 

    // const getUserNFTs = async (account, library, wl) => {
    //     const nfts = [];
    //     const web3 = new Web3(library.currentProvider);
    //     for(let i = 0; i< wl.length; i++) {
    //         const coll = new web3.eth.Contract(ERC721Artifacts.abi, wl[i]);
    //         const userBalForCollection = await coll.methods.balanceOf(account).call();
    //         for(let j = 0; j < userBalForCollection; j++) {
    //             const 
    //         }
    //     }
    // }

    const runTest = async (account, chainId, library) => {
        console.log(bridgeAddresses[chainId]);
        console.log(library);
        console.log(BridgeArtifacts);
        // const bridge = await ethers.getContract("Bridge", bridgeAddresses[chainId]);
        const web3 = new Web3(library.currentProvider);
        const bridge = new web3.eth.Contract(BridgeArtifacts.abi, bridgeAddresses[chainId]);
        // bridge.setProvider(library.currentProvider);

        console.log(bridge._address);
        console.log(await bridge.methods.currentChainId().call());
    }

    const verifyToken = async () => {
        console.log(tokenId);
        console.log(dstChainId);

        setVerifying(true);

        const web3 = await getWeb3(library);
        const coll = new web3.eth.Contract(ERC721Artifacts.abi, nftAddr[chainId]);
        console.log(coll)
        console.log(await coll.methods.name().call());

        // verify existence
        // const existence = await coll.methods.exists(parseInt(tokenId)).call();

        // verify ownership
        const owner = await coll.methods.ownerOf(parseInt(tokenId)).call();
        if(owner.toLowerCase() !== account.toLowerCase()) {
            setisVerified(false);
            alert("you are not the owner of this nft");
        } else {
            setisVerified(true);
        }
        setVerifying(false);
    }

    useEffect(()=>{
        if(account && chainId && library) {
            fetchNFTs(account, chainId);
            getWhitelistedNFTCollections(account, chainId, library);
        }
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [account, chainId]);

    const bridgeNFTs = async () => {
        // console.log();

        const web3 = new Web3(library.currentProvider);
        const bridge = new web3.eth.Contract(BridgeArtifacts.abi, bridgeAddresses[chainId]);

        // function transferToChain(
        //     uint16 _chainId,                            // send NFT to this chainId
        //     bytes calldata _srcERC721,                  // src NFT contract
        //     uint256 _srcERC721TokenId,                  // src NFT tokenId to bridge
        //     address payable _refundAddress,             // refund Address(LayerZero will refund any superfluos gas back to the caller of send())
        //     address _zroPaymentAddress,                 // zroPayment Address
        //     bytes calldata _txParameters   

        console.log(dstChainId);
        console.log(nftAddr[chainId]);
        console.log(tokenId);
        console.log(account);
        console.log(transactionValue);
        console.log("0x0000000000000000000000000000000000000000");
        // console.log();

        const coll = new web3.eth.Contract(ERC721Artifacts.abi, nftAddr[chainId]);
        const approveTx = await coll.methods.approve(bridge._address, parseInt(tokenId)).send({
            from: account
        })
        console.log(approveTx);

        const tx = await bridge.methods.transferToChain(
            parseInt(dstChainId),
            nftAddr[chainId],
            parseInt(tokenId),
            account,
            "0x0000000000000000000000000000000000000000",
            "0x"
        ).send({
            from: account,
            value: web3.utils.toWei(transactionValue, "ether")
        });

        console.log(tx);
    }

    return (
        <VStack
            p="30"
            mt="15"
            alignItems="stretch"
            boxShadow="lg"
            borderRadius="18"
            flex = "1"
            spacing = "5vh"
        >
            
            <Heading color="brand.primary" as="h1" size="lg">Bridge</Heading>

            <HStack flex= "1" alignItems="stretch" spacing="2rem"> 

                <VStack
                    p = "2rem"
                    boxShadow="base"
                    borderRadius="20px"
                    // justifyContent="space-between"
                    flex = "1"
                    border = "1px solid white"
                    spacing="10px"
                >
                    <Box>Contract: {chainId && nftAddr[chainId].substr(0,8)}...</Box>
                    <Box>Name: MultiChain ETH Global Hackers</Box>
                    <Box>Symbol: MEGH</Box>
                    <HStack>
                        <NumberInput onChange={(e)=>settokenId(e)} value={tokenId}>
                            <NumberInputField  />
                            <NumberInputStepper>
                                <NumberIncrementStepper />
                                <NumberDecrementStepper />
                            </NumberInputStepper>
                        </NumberInput>
                        <Button  onClick = {verifyToken}>{!isVerified ? "[⁉️] Verify ownership" : "[✅]"}</Button>
                    </HStack> 
                    <Box>
                        <Select placeholder='Select option' value={dstChainId} onChange={(e)=>setDstChainId(e.target.value)}>
                            <option value='10010'>Arbitrum Rinkeby</option>
                            <option value='10001'>Rinkeby</option>
                            <option disabled>Polygon Mumbai (soon! ETA 17 hours)</option>
                            <option disabled>Harmony (soon! ETA 17 hours)</option>
                            <option disabled>AVAX Fuji (soon! ETA 17 hours)</option>
                            <option disabled>Optimism (soon! ETA 12 hours)</option>
                            <option disabled>BSC Testnet (soon! ETA 42 hours)</option>
                        </Select>
                    </Box>
                    
                    <HStack
                        borderBottomRadius={"15px"} 
                        p="1rem" 
                        alignSelf="stretch" 
                        justifyContent = "space-between"
                        // fontWeight = "700"
                        // backgroundColor = { colorMode === "dark" ? "white" : "whitesmoke"}
                        // color = { colorMode === "dark" && "gray.800"}
                    >
                        <Box>Estimated tx value:</Box>
                        <Box>0.1 ETH</Box>
                        
                        
                    </HStack >
                    <Box>(extra amount will be refunded!)</Box>
                    <Button disabled={!isVerified} mt="10rem" w="100%" color="white" bgColor="brand.primary" size="lg" onClick={bridgeNFTs}>Bridge</Button>
                </VStack>

                <VStack  
                    flex= "1.5" 
                    boxShadow="base" 
                    borderRadius="20px"
                    p = "2rem"
                    border = "1px solid white"
                    alignItems="center"
                >
                    <Heading mb="15px" size="sm">Selected NFT TokenID(Art by Chris Dyer(@positivecreator)</Heading>
                    {tokenId &&
                        <Image boxShadow="dark-lg" w="20vw" loading="easy" fallbackSrc='https://via.placeholder.com/150' src={`https://ipfs.io/ipfs/Qmdi1NXLrmeT9gzLPniQGQUDesRPifofxxsqDPFJfpyhL6/${tokenId}.png`} />
                    }
                </VStack>
            </HStack>         
        </VStack>
    );
}

export default Bridge;